import { useCallback, useContext } from 'react';
import { NotificationsContext } from './Notifications';
export function useNotification() {
    const [, send] = useContext(NotificationsContext);
    const trigger = useCallback((content, { id, type, autoCloseAfter } = {}) => {
        send({
            type: 'NOTIFICATION.ADD',
            content,
            id,
            notificationType: type,
            autoCloseAfter
        });
    }, [send]);
    const dismiss = useCallback((id) => {
        if (typeof id === 'string') {
            send({ type: 'NOTIFICATION.REMOVE', id });
        }
        else {
            console.log('clearing');
            send({ type: 'NOTIFICATIONS.CLEAR' });
        }
    }, [send]);
    return [trigger, dismiss];
}
// trigger - content and an optional ID
// dismiss - optional ID. no id given = dismiss all
//# sourceMappingURL=useNotification.js.map